module.exports = __webpack_public_path__ + "static/plantify2-cf41315817ac291a3b44ded528e09d83.jpg";